import type {IconName} from '@wandb/components';

export type InfraProduct = {
  id: string;
  label: string;
  description: string;
  icon: IconName;
  /** Path on the console origin. */
  path: string;
};

export const DEFAULT_INFRA_CONSOLE_ORIGIN = 'https://console.coreweave.com';

export const INFRA_SESSION_STATUS_PATH = '/session-status';

export const INFRA_CONTACT_SALES_URL = 'https://www.coreweave.com/contact-us';

export const infraProducts: readonly InfraProduct[] = [
  {
    id: 'home',
    label: 'Home',
    description: 'Infrastructure at a glance',
    icon: 'home',
    path: '/',
  },
  {
    id: 'mission-control',
    label: 'Mission Control',
    description: 'Ask anything across Infrastructure',
    icon: 'lightboard',
    path: '/mission-control',
  },
  {
    id: 'infra-control',
    label: 'Infra Control',
    description: 'Compute, networking, data and storage',
    icon: 'monitor-cloud',
    path: '/infra-control',
  },
  {
    id: 'observability',
    label: 'Observability',
    description: 'Dashboards, alerts, and telemetry',
    icon: 'telescope',
    path: '/observability',
  },
  {
    id: 'workloads',
    label: 'Workloads',
    description: 'SUNK and inference',
    icon: 'versions-layers',
    path: '/workloads',
  },
  {
    id: 'access-control',
    label: 'Access Control',
    description: 'Users, groups, and access policies',
    icon: 'user-key',
    path: '/permissions',
  },
];

export const infraConsoleOrigin = (): string =>
  (
    window.__FORGE_SHELL_CONFIG__?.infraConsoleOrigin ??
    DEFAULT_INFRA_CONSOLE_ORIGIN
  ).replace(/\/$/, '');

export const infraConsoleHref = (path: string): string =>
  `${infraConsoleOrigin()}${path}`;
